import { render, staticRenderFns } from "./IncomeCalculator.vue?vue&type=template&id=664b4292&scoped=true&"
import script from "./IncomeCalculator.vue?vue&type=script&lang=js&"
export * from "./IncomeCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b4292",
  null
  
)

export default component.exports